// Vendor libraries
import { EventEmitter } from '@angular/core';
import { Store } from '@ngrx/store';
import { takeWhile } from 'rxjs/operators';
// Constants / utils
import { DELETE_HIDDEN_REPORT_TYPES, REPORT_TYPE_LEGACY_TEARSHEETS, REPORT_TYPE_LEGACY_Y_RATING, } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/constants';
import { memoizeOne } from 'NewAngular/utils/memoize-one';
// Services
import { CustomPDFReportService } from 'CustomPDFReportsApp/ts/services/custom-pdf-report.service';
import { CustomPDFReportModalEventName } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/enums/custom-pdf-report-modal-event-name.enum';
import { CustomPdfReportDataSourceEnum } from 'CustomPDFReportsApp/ts/enums/custom-pdf-report-data-source.enum';
// Actions
import { deleteReport, fetchReportMenu, setCurrentReportIndex, setCurrentReportTypeIndex, setReportMenuFetchFailure, setReportMenuFetchSuccess, } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/report-menu/report-menu.actions';
import { resetSelectedReport, setSelectedReport, } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/selected-report/selected-report.actions';
import { resetAllCustomPdfReportItems } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/actions';
import { incrementCurrentWizardStep } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/wizard-step/wizard-step.actions';
// Reducers
import { CUSTOM_PDF_REPORT_MODAL_STATE_SLICE_KEY } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/reducer';
// Selectors
import { getCurrentReportTypeIndex, getCurrentReportTypeName, getCurrentWizardStepIndex, getCustomPdfReportMenu, getMenuLoadingStatus, getPrimarySecurity, getReportMenuFetchRequest, getReportsForReportType, getSavedAnalysisPlanId, getSelectedReport, } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/selectors';
// Components
import { ConfirmModalComponent } from 'NewAngular/features/components/modals/confirm-modal/confirm-modal.component';
import { PreviewImageModalComponent } from 'NewAngular/features/components/modals/preview-image-modal/preview-image-modal.component';
import { AccountsService } from 'AccountsApp/ts/services/accounts.service';
import * as i0 from "@angular/core";
import * as i1 from "CustomPDFReportsApp/ts/services/custom-pdf-report.service";
import * as i2 from "AccountsApp/ts/services/accounts.service";
import * as i3 from "@ngrx/store";
import * as i4 from "@angular/common";
import * as i5 from "../../../../../../../../../ycharts/static/ts/features/components/modals/confirm-modal/confirm-modal.component";
import * as i6 from "@angular/forms";
import * as i7 from "../../../../../../../../../ycharts/static/ts/features/directives/icon/icon.directive";
import * as i8 from "../../../../../../../../../ycharts/static/ts/features/components/loaders/loading-symbol/loading-symbol.component";
import * as i9 from "../../../../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/modal-base.component";
import * as i10 from "../../../../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/simple-modal-footer.component";
import * as i11 from "../../../../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/simple-modal-header.component";
import * as i12 from "../../../../../../../../../ycharts/static/ts/features/components/modals/preview-image-modal/preview-image-modal.component";
import * as i13 from "../../../../../../../../../ycharts/static/ts/features/directives/popovers/tooltip/tooltip.directive";
const _c0 = ["confirmDeleteModal"];
const _c1 = a0 => ({ active: a0 });
function CustomPdfReportModalComponent_ycn_loading_symbol_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ycn-loading-symbol", 7);
} if (rf & 2) {
    i0.ɵɵproperty("loaderMessage", "Loading...");
} }
function CustomPdfReportModalComponent_div_3_li_6_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 33);
    i0.ɵɵlistener("click", function CustomPdfReportModalComponent_div_3_li_6_Template_li_click_0_listener() { const $index_r4 = i0.ɵɵrestoreView(_r3).index; const ctx_r4 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r4.updateReportTypeIndex($index_r4)); });
    i0.ɵɵelementStart(1, "a", 34);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const reportType_r6 = ctx.$implicit;
    const $index_r4 = ctx.index;
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵclassMap(i0.ɵɵpureFunction1(3, _c1, ctx_r4.currentReportTypeIndex === $index_r4));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(reportType_r6.name);
} }
function CustomPdfReportModalComponent_div_3_label_16_Template(rf, ctx) { if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "label", 35)(1, "input", 36);
    i0.ɵɵlistener("change", function CustomPdfReportModalComponent_div_3_label_16_Template_input_change_1_listener() { const option_r8 = i0.ɵɵrestoreView(_r7).$implicit; const ctx_r4 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r4.setOwnerOption(option_r8)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(2, "span", 37)(3, "span", 38);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const option_r8 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("id", option_r8.value)("checked", option_r8.checked);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("innerText", option_r8.label);
} }
function CustomPdfReportModalComponent_div_3_Conditional_23_Template(rf, ctx) { if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 39);
    i0.ɵɵlistener("click", function CustomPdfReportModalComponent_div_3_Conditional_23_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r10); const ctx_r4 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r4.setReportName("")); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(1, "svg", 40);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵproperty("name", "icon-close");
} }
function CustomPdfReportModalComponent_div_3_Conditional_24_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "button", 28);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(1, "svg", 40);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵproperty("name", "icon-search");
} }
function CustomPdfReportModalComponent_div_3_div_26_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r13 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 53);
    i0.ɵɵlistener("click", function CustomPdfReportModalComponent_div_3_div_26_div_5_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r13); const report_r12 = i0.ɵɵnextContext().$implicit; const ctx_r4 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r4.previewImageHandler(report_r12.preview_image_url)); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(1, "svg", 40);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵproperty("name", "icon-preview");
} }
function CustomPdfReportModalComponent_div_3_div_26_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r14 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 54);
    i0.ɵɵlistener("click", function CustomPdfReportModalComponent_div_3_div_26_div_6_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r14); const ctx_r4 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r4.deleteHandler()); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(1, "svg", 40);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵproperty("tooltipTitle", "Delete");
    i0.ɵɵadvance();
    i0.ɵɵproperty("name", "icon-delete");
} }
function CustomPdfReportModalComponent_div_3_div_26_p_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "p", 55);
} if (rf & 2) {
    const report_r12 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("textContent", "Owned by " + (report_r12.sharing == null ? null : report_r12.sharing.owner_name));
} }
function CustomPdfReportModalComponent_div_3_div_26_span_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 56);
    i0.ɵɵtext(1, "No description");
    i0.ɵɵelementEnd();
} }
function CustomPdfReportModalComponent_div_3_div_26_Template(rf, ctx) { if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 41)(1, "label", 42)(2, "input", 43);
    i0.ɵɵlistener("ngModelChange", function CustomPdfReportModalComponent_div_3_div_26_Template_input_ngModelChange_2_listener() { const report_r12 = i0.ɵɵrestoreView(_r11).$implicit; const ctx_r4 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r4.updateCurrentReport(report_r12)); });
    i0.ɵɵtwoWayListener("ngModelChange", function CustomPdfReportModalComponent_div_3_div_26_Template_input_ngModelChange_2_listener($event) { i0.ɵɵrestoreView(_r11); const ctx_r4 = i0.ɵɵnextContext(2); i0.ɵɵtwoWayBindingSet(ctx_r4.currentReportIndex, $event) || (ctx_r4.currentReportIndex = $event); return i0.ɵɵresetView($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "span", 37);
    i0.ɵɵelementStart(4, "div", 44);
    i0.ɵɵtemplate(5, CustomPdfReportModalComponent_div_3_div_26_div_5_Template, 2, 1, "div", 45)(6, CustomPdfReportModalComponent_div_3_div_26_div_6_Template, 2, 2, "div", 46);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 47);
    i0.ɵɵelement(8, "div", 48);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "div", 49);
    i0.ɵɵtemplate(10, CustomPdfReportModalComponent_div_3_div_26_p_10_Template, 1, 1, "p", 50);
    i0.ɵɵelement(11, "hr", 51);
    i0.ɵɵtemplate(12, CustomPdfReportModalComponent_div_3_div_26_span_12_Template, 2, 0, "span", 52);
    i0.ɵɵtext(13);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const report_r12 = ctx.$implicit;
    const $index_r15 = ctx.index;
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r4.currentReportIndex);
    i0.ɵɵproperty("value", $index_r15);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", report_r12.preview_image_url);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r4.canDeleteReport(report_r12.report_type, report_r12.sharing == null ? null : report_r12.sharing.is_owner));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("textContent", report_r12.report_name);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", report_r12.sharing);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !report_r12.report_description);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", report_r12.report_description, " ");
} }
function CustomPdfReportModalComponent_div_3_p_27_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 57);
    i0.ɵɵtext(1, " To change the timeframe and to hide or display the benchmark in the Level Chart, update selections on the security's Quote tab before generating your Tearsheet. ");
    i0.ɵɵelementEnd();
} }
function CustomPdfReportModalComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "div", 8)(2, "div", 9)(3, "div", 10)(4, "div", 11)(5, "ul", 12);
    i0.ɵɵtemplate(6, CustomPdfReportModalComponent_div_3_li_6_Template, 3, 5, "li", 13);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(7, "div", 14)(8, "div", 15)(9, "div", 16)(10, "div", 17)(11, "div", 18)(12, "div", 19)(13, "div", 20);
    i0.ɵɵtext(14, "Owner");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(15, "div", 21);
    i0.ɵɵtemplate(16, CustomPdfReportModalComponent_div_3_label_16_Template, 4, 3, "label", 22);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(17, "div", 23)(18, "div", 24)(19, "div", 25)(20, "input", 26, 1);
    i0.ɵɵlistener("input", function CustomPdfReportModalComponent_div_3_Template_input_input_20_listener() { i0.ɵɵrestoreView(_r2); const reportNameFilterInput_r9 = i0.ɵɵreference(21); const ctx_r4 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r4.setReportName(reportNameFilterInput_r9.value)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(22, "div", 27);
    i0.ɵɵtemplate(23, CustomPdfReportModalComponent_div_3_Conditional_23_Template, 2, 1, "button", 28)(24, CustomPdfReportModalComponent_div_3_Conditional_24_Template, 2, 1);
    i0.ɵɵelementEnd()()()()();
    i0.ɵɵelementStart(25, "div", 29);
    i0.ɵɵtemplate(26, CustomPdfReportModalComponent_div_3_div_26_Template, 14, 8, "div", 30);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(27, CustomPdfReportModalComponent_div_3_p_27_Template, 2, 0, "p", 31);
    i0.ɵɵelementEnd()()()()();
    i0.ɵɵelementStart(28, "ycn-simple-modal-footer", 32);
    i0.ɵɵlistener("cancelHandler", function CustomPdfReportModalComponent_div_3_Template_ycn_simple_modal_footer_cancelHandler_28_listener() { i0.ɵɵrestoreView(_r2); const ctx_r4 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r4.exitModalHandler()); })("submitHandler", function CustomPdfReportModalComponent_div_3_Template_ycn_simple_modal_footer_submitHandler_28_listener() { i0.ɵɵrestoreView(_r2); const ctx_r4 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r4.forward()); });
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("ngForOf", ctx_r4.customPdfReportMenu);
    i0.ɵɵadvance(10);
    i0.ɵɵproperty("ngForOf", ctx_r4.ownerOptions)("ngForTrackBy", ctx_r4.ownerOptionValue);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("value", ctx_r4.reportNameFilter);
    i0.ɵɵadvance(3);
    i0.ɵɵconditional(23, ctx_r4.reportNameFilter ? 23 : 24);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngForOf", ctx_r4.visibleReports)("ngForTrackBy", ctx_r4.trackById);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r4.currentReportTypeInternalName === ctx_r4.tearsheetsInternalName);
    i0.ɵɵadvance();
    i0.ɵɵproperty("cancelButtonText", "Reset")("errorText", ctx_r4.errorText)("submitButtonText", ctx_r4.submitButtonText)("disableSubmission", ctx_r4.currentReportIndex === null || ctx_r4.isReportValidatingOrInvalid);
} }
const OWNER_OPTIONS = [
    {
        label: 'Me',
        value: 'me',
        checked: true,
    },
    {
        label: 'Shared with me',
        value: 'shared_with_me',
        checked: true,
    },
    {
        label: 'Public',
        value: 'public',
        checked: true,
    },
];
/**
 * Custom PDF Report Modal Component
 *
 * This component displays the menu of Custom PDF Reports organized by report type.
 * It is typically the first modal displayed in the Custom PDF Report generation process.
 *
 * Output Properties:
 *  broadcastWizardStepEvent: emits when moving to the next wizard step in the report generation process.
 *
 */
export class CustomPdfReportModalComponent {
    constructor(customPDFReportService, accountsService, store) {
        this.customPDFReportService = customPDFReportService;
        this.accountsService = accountsService;
        this.store = store;
        this.broadcastWizardStepEvent = new EventEmitter();
        this.currentReportIndex = null;
        this.securityId = '';
        this.IsWatchlist = false;
        this.isLoading = true;
        this.modalOpen = false;
        this.currentTypeReports = [];
        this.visibleReports = [];
        this.currentReportTypeInternalName = '';
        this.tearsheetsInternalName = REPORT_TYPE_LEGACY_TEARSHEETS;
        this.customPdfReportMenu = [];
        this.ownerOptions = OWNER_OPTIONS;
        this.reportNameFilter = '';
        this.submitButtonText = 'Start';
        this.onePageReportTypes = new Set([REPORT_TYPE_LEGACY_TEARSHEETS, REPORT_TYPE_LEGACY_Y_RATING]);
        this.fetchRequest = { fetching: false, error: null, status: null };
        this.reportMenuFetchSubscription = null;
        this.isAlive = true;
        this.isReportValidatingOrInvalid = false;
        this.selectedAnalysisPlanId = null;
        this.mapStateToComponent = (state) => {
            const { securityId, securityListGroup } = getPrimarySecurity(state);
            this.securityId = securityId ?? '';
            this.securityListGroup = securityListGroup;
            this.selectedAnalysisPlanId = getSavedAnalysisPlanId(state);
            const selectedReport = getSelectedReport(state);
            if (state.primarySecurity.securityId &&
                !Object.keys(selectedReport).length &&
                !this.modalOpen &&
                getCurrentWizardStepIndex(state) === 0) {
                this.fetchReportMenu();
                this.clearReportFilters();
                this.openModal();
            }
            this.customPdfReportMenu = getCustomPdfReportMenu(state);
            this.fetchRequest = getReportMenuFetchRequest(state);
            this.isLoading = getMenuLoadingStatus(state);
            this.selectedReport = selectedReport;
            this.currentReportTypeIndex = getCurrentReportTypeIndex(state);
            this.currentTypeReports = getReportsForReportType(state);
            this.currentReportTypeInternalName = getCurrentReportTypeName(state);
            this.submitButtonText = this.onePageReportTypes.has(this.currentReportTypeInternalName) ? 'Generate' : 'Start';
            if (this.modalOpen)
                this.filterVisibleReports();
        };
        this.filterAvailableReports = (typeReports) => {
            if (this.selectedAnalysisPlanId !== null) {
                const interactiveAnalysisStep = CustomPDFReportModalEventName.SHOW_SELECT_INTERACTIVE_ANALYSIS_MODAL;
                const reports = typeReports.reports
                    .filter((r) => r.wizard_steps?.some((s) => s.eventName === interactiveAnalysisStep))
                    .map((r) => ({
                    ...r,
                    wizard_steps: r.wizard_steps.filter((s) => s.eventName !== interactiveAnalysisStep),
                }));
                return { name: typeReports.name, reports };
            }
            return typeReports;
        };
        this.canDeleteReport = memoizeOne((reportType, is_owner) => {
            return !DELETE_HIDDEN_REPORT_TYPES.includes(reportType) && is_owner;
        });
        this.store
            .select(CUSTOM_PDF_REPORT_MODAL_STATE_SLICE_KEY)
            .pipe(takeWhile(() => this.isAlive))
            .subscribe(this.mapStateToComponent);
        this.accountsService.getUserPreferences().subscribe({
            next: (preferences) => {
                this.dataSource = preferences.use_generic_data_display
                    ? CustomPdfReportDataSourceEnum.DEFAULT
                    : CustomPdfReportDataSourceEnum.LEGACY;
            },
            error: () => {
                this.dataSource = CustomPdfReportDataSourceEnum.LEGACY; // TODO: change this to DEFAULT when data switch happens
                // https://app.asana.com/0/1207424818771538/1207992229300869/f
            },
        });
    }
    ngOnDestroy() {
        this.isAlive = false;
    }
    fetchReportMenu() {
        if (this.reportMenuFetchSubscription !== null) {
            this.reportMenuFetchSubscription.unsubscribe();
        }
        this.store.dispatch(fetchReportMenu());
        this.IsWatchlist = this.securityId?.startsWith('watchlist-');
        const params = this.IsWatchlist
            ? { securitylistName: this.securityId, dataSource: this.dataSource }
            : { securityId: this.securityId, dataSource: this.dataSource };
        this.reportMenuFetchSubscription = this.customPDFReportService
            .getPDFReports(params)
            .pipe(takeWhile(() => this.isAlive))
            .subscribe({
            next: (res) => {
                const filteredReports = res.map(this.filterAvailableReports);
                const data = filteredReports.filter((reportType) => reportType.reports?.length > 0);
                if (!data.length) {
                    if (this.IsWatchlist) {
                        this.errorText =
                            'The files could not be generated because the security list ' +
                                'does not contain at least one supported security type.';
                    }
                    else if (this.selectedAnalysisPlanId) {
                        this.errorText =
                            'No interactive analysis reports have been found; ' +
                                'please create a report with interactive analysis modules ' +
                                'or contact support.';
                    }
                    else {
                        this.errorText = 'No available reports';
                    }
                    this.store.dispatch(setReportMenuFetchFailure({ error: this.errorText }));
                    return;
                }
                this.store.dispatch(setReportMenuFetchSuccess({ data }));
            },
            error: () => {
                this.errorText = 'Unable to fetch reports; please refresh the page or contact support.';
                this.store.dispatch(setReportMenuFetchFailure({ error: this.errorText }));
            },
        });
    }
    setOwnerOption(option) {
        this.ownerOptions = this.ownerOptions.map((checkboxOption) => ({
            ...checkboxOption,
            checked: checkboxOption.value === option.value ? !checkboxOption.checked : checkboxOption.checked,
        }));
        this.filterVisibleReports();
    }
    ownerOptionValue(_index, option) {
        return option.value;
    }
    setReportName(newReportName) {
        this.reportNameFilter = newReportName;
        this.filterVisibleReports();
    }
    filterVisibleReports() {
        const nameFilter = this.reportNameFilter.toLowerCase();
        const meFilter = this.ownerOptions.find((option) => option.value === 'me')?.checked;
        const sharedFilter = this.ownerOptions.find((option) => option.value === 'shared_with_me')?.checked;
        const publicFilter = this.ownerOptions.find((option) => option.value === 'public')?.checked;
        this.visibleReports = this.currentTypeReports.filter((report) => {
            if (this.reportNameFilter.length > 0 && !report.report_name.toLowerCase().includes(nameFilter)) {
                return false;
            }
            // Treat legacy tearsheets as public items
            if (!report.sharing)
                return publicFilter;
            if (report.sharing.is_owner) {
                return meFilter;
            }
            return ((sharedFilter || report.sharing.is_client_group_public) &&
                (publicFilter || !report.sharing.is_client_group_public));
        });
        if (this.isReportSelected() && this.modalOpen) {
            this.currentReportIndex = this.visibleReports.findIndex((report) => this.selectedReport.report_id === report.report_id ||
                (!this.selectedReport.report_id && this.selectedReport.report_name === report.report_name));
            if (this.currentReportIndex < 0)
                this.clearSelectedReport();
        }
    }
    updateReportTypeIndex(index) {
        this.store.dispatch(setCurrentReportTypeIndex({ index }));
        this.clearSelectedReport();
    }
    clearSelectedReport() {
        this.currentReportIndex = null;
        this.store.dispatch(setCurrentReportIndex({ index: null }));
        this.store.dispatch(resetSelectedReport());
    }
    clearReportFilters() {
        this.ownerOptions = OWNER_OPTIONS;
        this.reportNameFilter = '';
    }
    updateCurrentReport(report) {
        let index = this.currentTypeReports.findIndex((r) => r === report);
        if (index < 0)
            index = null;
        this.store.dispatch(setCurrentReportIndex({ index }));
        if (report && index != null) {
            let reportObject = report;
            if (this.IsWatchlist) {
                this.errorText = '';
                this.isReportValidatingOrInvalid = false;
                reportObject = {
                    ...reportObject,
                    wizard_steps: reportObject.wizard_steps.filter((step) => step.eventName !== CustomPDFReportModalEventName.SHOW_SECURITY_SEARCH_MODAL),
                };
                reportObject.wizard_steps.splice(1, 0, {
                    eventName: CustomPDFReportModalEventName.SHOW_EXPORT_OPTIONS_MODAL,
                });
            }
            this.store.dispatch(setSelectedReport({ reportData: reportObject }));
        }
        else {
            this.store.dispatch(resetSelectedReport());
        }
    }
    openModal() {
        this.modalOpen = true;
        // If report is not selected, reset indexes so a check mark is not displayed
        if (!this.isReportSelected()) {
            this.store.dispatch(setCurrentReportTypeIndex({ index: this.currentReportTypeIndex }));
            this.store.dispatch(setCurrentReportIndex({ index: null }));
        }
    }
    closeModal() {
        this.modalOpen = false;
        this.errorText = undefined;
    }
    exitModalHandler() {
        this.store.dispatch(resetAllCustomPdfReportItems());
        this.closeModal();
        this.clearSelectedReport();
        this.clearReportFilters();
    }
    previewImageHandler(previewImageURL) {
        if (this.previewImageModalComponent) {
            this.previewImageModalComponent.openModal(previewImageURL);
        }
    }
    isReportSelected() {
        return (this.selectedReport !== null &&
            this.selectedReport !== undefined &&
            Object.keys(this.selectedReport).length > 0);
    }
    forward() {
        if (this.isReportSelected()) {
            if (this.IsWatchlist) {
                this.isReportValidatingOrInvalid = true;
                this.customPDFReportService
                    .validateReportSecurityList(this.selectedReport.report_id ?? 0, this.securityId, this.securityListGroup, !this.selectedReport.report_id)
                    .subscribe({
                    next: (response) => {
                        this.errorText = response.message_text;
                        this.isReportValidatingOrInvalid =
                            this.errorText.includes('Security list is too large') ||
                                this.errorText.includes('Selected list has no securities');
                        if (!this.isReportValidatingOrInvalid) {
                            this.closeModal();
                            this.store.dispatch(incrementCurrentWizardStep());
                            this.broadcastWizardStepEvent.emit();
                        }
                    },
                    error: () => {
                        this.errorText = 'Error validating report';
                    },
                });
            }
            else {
                this.closeModal();
                this.store.dispatch(incrementCurrentWizardStep());
                this.broadcastWizardStepEvent.emit();
            }
        }
    }
    deleteHandler() {
        this.confirmDeleteModal.openModal();
    }
    confirmDeleteHandler(confirmed) {
        if (confirmed) {
            const { report_id, report_category } = this.selectedReport;
            this.customPDFReportService.deletePDFReport(report_id).subscribe({
                next: () => {
                    this.store.dispatch(deleteReport({ reportId: report_id, reportCategory: report_category }));
                    this.store.dispatch(setCurrentReportIndex({ index: null }));
                    this.store.dispatch(resetSelectedReport());
                },
                error: () => {
                    this.errorText = 'Unable to delete report. Please try again or contact support.';
                },
            });
        }
    }
    trackById(index, report) {
        return report.report_id;
    }
}
CustomPdfReportModalComponent.ɵfac = function CustomPdfReportModalComponent_Factory(t) { return new (t || CustomPdfReportModalComponent)(i0.ɵɵdirectiveInject(i1.CustomPDFReportService), i0.ɵɵdirectiveInject(i2.AccountsService), i0.ɵɵdirectiveInject(i3.Store)); };
CustomPdfReportModalComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: CustomPdfReportModalComponent, selectors: [["ycn-custom-pdf-report-modal"]], viewQuery: function CustomPdfReportModalComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(PreviewImageModalComponent, 5);
        i0.ɵɵviewQuery(_c0, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.previewImageModalComponent = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.confirmDeleteModal = _t.first);
    } }, outputs: { broadcastWizardStepEvent: "broadcastWizardStepEvent" }, decls: 7, vars: 8, consts: [["confirmDeleteModal", ""], ["reportNameFilterInput", ""], [3, "closeModalHandler", "open", "extraModalClasses"], [3, "closeModalHandler", "header"], [3, "loaderMessage", 4, "ngIf"], [4, "ngIf"], [3, "confirmHandler", "confirmButtonText", "confirmHeader", "confirmText"], [3, "loaderMessage"], [1, "modal-content"], [1, "modal-body"], [1, "tabs-vertical-wrap", "ng-scope"], [1, "tabs", "tabs-vertical"], [1, "nav", "nav-tabs"], ["class", "nav-item", 3, "click", 4, "ngFor", "ngForOf"], [1, "tab-content"], [1, "tab-pane", "active", "overflow-shadow"], [1, "tab-pane-inner", "overflow-shadow-inner"], [1, "d-flex", "align-items-end", "pt-12"], [1, "flex-auto"], [1, "mb-1"], [1, "form-label", "form-label-thin"], [1, "form-inline"], ["class", "custom-control custom-checkbox mr-1", 4, "ngFor", "ngForOf", "ngForTrackBy"], [1, "width-125"], [1, "input-group", "ng-scope"], [1, "input-group", "field-input-group"], ["placeholder", "Search", 1, "form-control", "field-input", 3, "input", "value"], [1, "field-input-group-actions"], [1, "btn", "btn-transparent"], [1, "report-modules"], ["class", "report-module-container", 4, "ngFor", "ngForOf", "ngForTrackBy"], ["class", "footnote", 4, "ngIf"], [3, "cancelHandler", "submitHandler", "cancelButtonText", "errorText", "submitButtonText", "disableSubmission"], [1, "nav-item", 3, "click"], [1, "nav-link", 2, "cursor", "pointer"], [1, "custom-control", "custom-checkbox", "mr-1"], ["type", "checkbox", "name", "", 1, "custom-control-input", 3, "change", "id", "checked"], [1, "custom-control-indicator"], [1, "custom-control-description", 3, "innerText"], [1, "btn", "btn-transparent", 3, "click"], ["ycnIcon", "", 3, "name"], [1, "report-module-container"], [1, "template-module", "custom-control", "custom-radio"], ["type", "radio", 1, "custom-control-input", 3, "ngModelChange", "ngModel", "value"], [1, "template-module-controls"], ["class", "btn btn-circle btn-transparent btn-preview", 3, "click", 4, "ngIf"], ["class", "btn btn-circle btn-transparent btn-delete", "ycnTooltip", "", 3, "tooltipTitle", "click", 4, "ngIf"], [1, "template-module-header", "user-select-none"], [1, "template-module-title", 3, "textContent"], [1, "template-module-body", "user-select-none"], [3, "textContent", 4, "ngIf"], [1, "hr"], ["class", "text-gray-60", 4, "ngIf"], [1, "btn", "btn-circle", "btn-transparent", "btn-preview", 3, "click"], ["ycnTooltip", "", 1, "btn", "btn-circle", "btn-transparent", "btn-delete", 3, "click", "tooltipTitle"], [3, "textContent"], [1, "text-gray-60"], [1, "footnote"]], template: function CustomPdfReportModalComponent_Template(rf, ctx) { if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "ycn-modal-base", 2);
        i0.ɵɵlistener("closeModalHandler", function CustomPdfReportModalComponent_Template_ycn_modal_base_closeModalHandler_0_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.closeModal()); });
        i0.ɵɵelementStart(1, "ycn-simple-modal-header", 3);
        i0.ɵɵlistener("closeModalHandler", function CustomPdfReportModalComponent_Template_ycn_simple_modal_header_closeModalHandler_1_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.exitModalHandler()); });
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(2, CustomPdfReportModalComponent_ycn_loading_symbol_2_Template, 1, 1, "ycn-loading-symbol", 4)(3, CustomPdfReportModalComponent_div_3_Template, 29, 12, "div", 5);
        i0.ɵɵelementEnd();
        i0.ɵɵelement(4, "ycn-preview-image-modal");
        i0.ɵɵelementStart(5, "ycn-confirm-modal", 6, 0);
        i0.ɵɵlistener("confirmHandler", function CustomPdfReportModalComponent_Template_ycn_confirm_modal_confirmHandler_5_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.confirmDeleteHandler($event)); });
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("open", ctx.modalOpen)("extraModalClasses", "modal-dialog modal-no-border");
        i0.ɵɵadvance();
        i0.ɵɵproperty("header", "Generate Report");
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.isLoading);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", !ctx.isLoading);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("confirmButtonText", "DELETE")("confirmHeader", "Delete Report")("confirmText", "Are you sure you want to delete this report?<br><br><strong>Note:</strong> Deleting this report template will remove it permanently for all future use across all asset types.");
    } }, dependencies: [i4.NgForOf, i4.NgIf, i5.ConfirmModalComponent, i6.DefaultValueAccessor, i6.RadioControlValueAccessor, i6.NgControlStatus, i6.NgModel, i7.IconDirective, i8.LoadingSymbolComponent, i9.ModalBaseComponent, i10.SimpleModalFooterComponent, i11.SimpleModalHeaderComponent, i12.PreviewImageModalComponent, i13.TooltipDirective], encapsulation: 2 });
